module.exports = __webpack_public_path__ + "7d088296/img/splash-icon.07a7c465.svg";